module.exports = __webpack_public_path__ + "step1.80d44684.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step1.jpg
// module id = Ftv8
// module chunks = 0